/* eslint-disable prettier/prettier */
import React, { useState } from 'react'
import useStyles from './styles'
import { CircularProgress, IconButton } from '@material-ui/core'
import VideocamOffIcon from '@material-ui/icons/VideocamOff'
import VideocamIcon from '@material-ui/icons/Videocam'
import FullscreenIcon from '@material-ui/icons/Fullscreen'
import VolumeUpIcon from '@material-ui/icons/VolumeUp'
import VolumeOffIcon from '@material-ui/icons/VolumeOff'
import SyncIcon from '@material-ui/icons/Sync'
import { useSelector, useDispatch } from 'react-redux'
import {
  setVideoDisplay,
  setCaptionsDisplay,
  getServerTime
} from 'actions/stream'
import { setAudioSetting } from 'actions/stream'
import ClosedCaptionIcon from '@material-ui/icons/ClosedCaption'
import ClosedCaptionOutlinedIcon from '@material-ui/icons/ClosedCaptionOutlined'
import classnames from 'clsx'
import ChromeCastButton from './ChromeCastButton'

const VideoButtons = ({
  handleFullscreen,
  handleAudio,
  cloudinaryRef,
  egliveRef,
  streamId
}) => {
  const classes = useStyles()
  // const cloudinaryMediaControl = useMediaControls(cloudinaryRef)
  // const egliveMediaControl = useMediaControls(egliveRef)

  const dispatch = useDispatch()

  const displayVideo = useSelector(state => state.stream.displayVideo)
  const displayCaptions = useSelector(state => state.stream.captions)
  const audioSetting = useSelector(state => state.stream.audioSetting)
  const gotCaptions = useSelector(state => state.stream.gotCaptions)
  const captionsPaid = useSelector(state => state.event.event.paid_captions)
  const showDisplay = useSelector(state => state.stream.showDisplayVideo)
  const replayMode = useSelector(
    state => state.event.event.live_settings.replay_mode
  )
  const popoutMode = useSelector(state => state.window.popoutMode)
  const handleToggleVideoDisplay = () => {
    dispatch(setVideoDisplay(!displayVideo))
  }
  const handleToggleCaptionsDisplay = () => {
    dispatch(setCaptionsDisplay(!displayCaptions))
  }

  const handleToggleAudioSetting = () => {
    dispatch(setAudioSetting(!audioSetting))
  }

  const syncPlayHead = () => {
    setTimeout(() => {
      setTimeout(async function() {
        //console.log(cloudinaryRef.current)
        await dispatch(getServerTime(streamId)).then(data => {
          //set the videoplayhead to that according the server
          //console.log('reset the playhead ')
          cloudinaryRef.current.currentTime = data
        })
      }, 1000)
    })
  }

  return (
    <div
      className={classnames(classes.videoButtons, {
        [classes.popoutMode]: popoutMode
      })}
    >
      <IconButton
        className={classes.buttonBackground}
        onClick={syncPlayHead}
        aria-label="Sync Video with Server"
      >
        <SyncIcon />
      </IconButton>
      <IconButton className={classes.buttonBackground}>
        <google-cast-launcher class={classes.cast} />
      </IconButton>
      {Number(captionsPaid) === 1 && !replayMode && (
        <IconButton
          className={classnames(classes.buttonBackground, {
            [classes.buttonActive]: displayCaptions
          })}
          classes={{
            label: classes.iconButtonLabel
          }}
          onClick={handleToggleCaptionsDisplay}
          aria-label="Captions Button"
        >
          {displayCaptions && !gotCaptions && (
            <CircularProgress
              size="small"
              color="secondary"
              className={classes.spinner}
            />
          )}
          {displayCaptions && <ClosedCaptionIcon />}
          {!displayCaptions && <ClosedCaptionOutlinedIcon />}
        </IconButton>
      )}
      <IconButton
        className={classes.buttonBackground}
        onClick={handleToggleAudioSetting}
        aria-label="Mute Button"
      >
        {audioSetting && <VolumeOffIcon />}
        {!audioSetting && <VolumeUpIcon />}
      </IconButton>
      {!showDisplay && (
        <IconButton
          className={classes.buttonBackground}
          onClick={handleToggleVideoDisplay}
          aria-label="Videocam Buttom"
        >
          {displayVideo && <VideocamIcon />}
          {!displayVideo && <VideocamOffIcon />}
        </IconButton>
      )}
      <IconButton
        className={classes.buttonBackground}
        onClick={handleFullscreen}
        aria-label="Fullscreen Button"
      >
        <FullscreenIcon />
      </IconButton>
    </div>
  )
}

export default VideoButtons



// WEBPACK FOOTER //
// ./src/components/VideoButtons/index.jsx